module.exports = __webpack_public_path__ + "static/img/space_title.a4e7f72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/daas_case/space_title.png
// module id = jt+S
// module chunks = 0